// useAuthService.ts

import { useContext } from "react";

import UserContext from "context/User";
import { getVerification } from "api/Auth";

const useAuthService = () => {

  const { user, setUser } = useContext<any>(UserContext);

  const logout = (): void => {
    setUser(null);
    localStorage.removeItem('authorized');
  };

  const authenticate = async (): Promise<boolean> => {
    if (user?.token) {
      const res = await getVerification();
      if(!res?.user?.id) {
        logout();
        return false;
      }
      setUser({...res?.user })
      return true;
    }

    const authorized = localStorage.getItem("user");
    const data = JSON.parse(authorized || "{}");
    if (!!data?.tokens) {
      if (data?.tokens?.expires < Date.now()) {
        logout();
        return false;
      } else {
        const res = await getVerification();
        if(!res?.user?.id) {
          logout();
          return false;
        }
        setUser({...res?.user })
        return true;
      }
    }

    logout();
    return false;

  }
  

  return { authenticate };
};

export default useAuthService;
